'use client';
/**
 * L5 perf — 서버가 읽은 성능 스위치를 클라이언트 부품(CardImg 등)에 내리는 컨텍스트. DOM 을 그리지 않는다(SSR HTML 불변).
 * 공급자가 없으면 기본값(imgResponsive=true) — 시험·독립 렌더에서도 같은 마크업.
 */
import { createContext, useContext, type ReactNode } from 'react';

export interface PerfFlags { imgResponsive: boolean }

export const DEFAULT_PERF_FLAGS: PerfFlags = { imgResponsive: true };

const Ctx = createContext<PerfFlags>(DEFAULT_PERF_FLAGS);

export function PerfFlagsProvider({ value, children }: { value: PerfFlags; children?: ReactNode }) {
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function usePerfFlags(): PerfFlags {
  return useContext(Ctx);
}
